<template>
    <div>
        <Collapse v-model="value" simple style="border:0">
            <Panel name="1" hide-arrow style="margin: 20px 0;border:0" >
                <FormTitle :titleText="$t('Education_Background')"/><!-- 教育背景 -->
                <div slot="content" style="margin-top: 40px;">
                    <Table border :loading="loading" :columns="columns" :data="data"> </Table>
                    <div style="margin:20px 0;">
                        <Page style="float: right" :total="total" @on-change="pageChange"/>
                    </div>
                </div>
            </Panel>
            <div  v-if="id==''">
                <span style="color: red;">{{$t('EmpFilesComment')}}</span>
            </div> 
        </Collapse>
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            formItem:{},
            list:[],
            value:[1],
            date: new DateUtil(),
            loading:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[],
            id:'',
            serialnumber:''
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('Start_Date'),/* 开始日期 */
                    key: "programstartdate",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    render: (h, params) => {
                        return h(
                            "span",
                            this.date.dateVal(params.row.programstartdate, "YYYY-MM-DD")
                        );
                    },
                },{
                    title: this.$t('Graduation_Date'),/* 毕业日期 */
                    key: "graduatedate",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    render: (h, params) => {
                        return h(
                            "span",
                            this.date.dateVal(params.row.graduatedate, "YYYY-MM-DD")
                        );
                    },
                },{
                    title: this.$t('School'),/* 学校名称 */
                    key: "school",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    
                },{
                    title: this.$t('Major'),/* 专业名称 */
                    key: "major",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },
                {
                    title: this.$t('Academic_Level'),/* 学历 */
                    key: "degree",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },
                {
                    title: this.$t('_Degree'),/* 学位 */
                    key: "academicdegree",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },
                {
                    title: this.$t('Program_Duration'),/* 学年制 */
                    key: "programyears",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },
                {
                    title: this.$t('Highest_Education'),/* 最高学历 */
                    key: "highest",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },
            ]
        }
    },
    methods:{
         getData(val){
            this.loading=true
            val?this.serialnumber=val:this.serialnumber=JSON.parse(sessionStorage.getItem("userInfo")).serialnumber
            axios.post("/educationalBackground/getEducationalBackground", {...this.pageInfo,serialnumber:this.serialnumber}).then((res) => {
                this.loading=false
                if (res) {
                   this.data=res.data
                   this.total=parseInt(res.pageInfo.total)
                }
            })
        },
        pageChange(val){
            this.pageInfo.pageNo = val
            this.getData(this.serialnumber)
        },
    }
}
</script>

<style lang="less" scoped>
.btnfooter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/components/EducationBackground.vue